import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../../img/Vector.svg';
import i18n from "i18next";
import Cookies from "js-cookie";
import MobileMenu from "./MobileMenu";

function Header({ currentLang, storedLang, setCurrentLang }) {
  const location = useLocation();

  const languages = [
    {
      value: 'en',
      label: 'EN',
    },
    {
      value: 'ar',
      label: 'AR',
    },
    {
      value: 'tr',
      label: 'TR',
    },
  ];

  const languageChangeMessages = {
    en: 'Changing language to English',
    ar: 'تغيير اللغة إلى العربية',
    tr: 'Dil Türkçe olarak değiştiriliyor',
  };

  useEffect(() => {
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
      i18n.changeLanguage(storedLang);
    }
    document.body.setAttribute('dir', currentLang === 'ar' ? 'rtl' : 'ltr');
  }, [storedLang, currentLang, setCurrentLang]);

  const handleChangeLang = (selectedLang) => {
    if (selectedLang.value === currentLang) {
      setIsOpenLang(false);
      return;
    }
    const loader = document.getElementById('loader');
    const loaderMessage = document.getElementById('loader-message');

    if (loaderMessage) {
      loaderMessage.textContent = languageChangeMessages[selectedLang.value] || languageChangeMessages.en;
      loaderMessage.dir = selectedLang.value === 'ar' ? 'rtl' : 'ltr';
    }

    loader?.classList.add('is-language-change');
    loader?.classList.remove('hide'); // Показываем лоадер

    setTimeout(() => {
      i18n.changeLanguage(selectedLang.value); // Меняем язык
      setCurrentLang(selectedLang.value);
      Cookies.set("i18next", selectedLang.value);
    }, 1000); // Задержка для анимации лоадера (500 мс)
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLang, setIsOpenLang] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isOpen) {
      document.documentElement.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : originalPaddingRight;
    } else {
      document.body.classList.remove('menu-open');
      document.documentElement.style.removeProperty('--scrollbar-compensation');
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    }

    return () => {
      document.body.classList.remove('menu-open');
      document.documentElement.style.removeProperty('--scrollbar-compensation');
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, [isOpen]);

  const [isScrolledPastHeight, setIsScrolledPastHeight] = useState(true);
  const [MainMenu, setMainMenu] = useState(false);

  useEffect(() => {
    if (location.pathname !== "/") {
      setIsScrolledPastHeight(true); // На всех страницах кроме главной — фон всегда белый
      setMainMenu(true);
    } else {
      setMainMenu(false);

      const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        setIsScrolledPastHeight(!(scrollY + 100 >= windowHeight));
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [location.pathname]);

  // Закрываем выпадающее меню при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      const menuElement = document.getElementById('languageMenu');
      if (menuElement && !menuElement.contains(event.target)) {
        setIsOpenLang(false); // Закрываем меню
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <header>
        <div className={`scrollbar-compensate h-[60px] md:h-[80px] fixed z-[999] w-full transition-colors bg-white`}>
          <div className={`max-w-[1280px] mx-[20px] h-[60px] md:h-[80px] xl:mx-auto flex items-center justify-between`}>
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                width="100"
                height="38"
                fetchPriority="high"
                loading="eager"
                className={`w-[100px] z-[500] relative transition-all duration-500`}
              />
            </Link>
            <div className="flex items-center gap-[10px]">
              <div className="relative z-[1000]" id="languageMenu">
                <button
                  type="button"
                  className={`inter flex h-[34px] w-[61px] items-center justify-center gap-[8px] rounded-[20px] border border-[rgba(0,0,0,0.20)] bg-white text-[16px] font-[400] leading-[1.5] text-[rgba(0,0,0,0.70)] transition-colors ${isScrolledPastHeight ? '' : 'bg-white'}`}
                  onClick={() => setIsOpenLang(!isOpenLang)}
                  aria-expanded={isOpenLang}
                  aria-label="Change language"
                >
                  <span>{languages.find(lang => lang.value === currentLang)?.label}</span>
                  <svg className={`transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpenLang ? 'rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 16 9" fill="none">
                    <path d="M1 1L8 8L15 1" stroke="#000000" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                <div className={`absolute top-[calc(100%+10px)] ltr:right-0 rtl:left-0 flex h-[76px] w-[59px] flex-col overflow-hidden rounded-[10px] border border-[rgba(0,0,0,0.20)] bg-white transition-all duration-200 ease-[cubic-bezier(0.22,1,0.36,1)] ${isOpenLang ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-[-6px] opacity-0'}`}>
                    {languages.filter((lang) => lang.value !== currentLang).map((lang) => (
                      <button
                        type="button"
                        key={lang.value}
                        className="inter flex flex-1 items-center justify-center text-[14px] font-[400] leading-[1.5] text-[rgba(0,0,0,0.70)] transition-colors hover:bg-[#0000000A]"
                        onClick={() => handleChangeLang(lang) || setIsOpenLang(false)}
                      >
                        {lang.label}
                      </button>
                    ))}
                  </div>
              </div>
              <MobileMenu currentLang={currentLang} isScrolledPastHeight={isScrolledPastHeight} MainMenu={MainMenu} toggleMenu={toggleMenu} isOpen={isOpen}/>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
